import { cn } from '@/libs/tw'

type ContentContainerProps = {
	children: JSX.Element
}

export const ContentContainer = ({ children }: ContentContainerProps) => {
	return <div className={cn('w-full max-w-content px-24 2xl:px-0')}>{children}</div>
}
